module.exports = __webpack_public_path__ + "static/media/logo-w.7e5bc268.svg";